import React from 'react'

export default function RishikeshDining() {
  return (
    <>
    <section className="rishikesh-dining">
        <div className="container">
            <div className="row">
                 
                <div className="col-lg-12">
                    <h4 className='heading'>Gourmet Dining Experience</h4>
                </div>

                <div className="col-lg-7 col-sm-7 col-md-7 order-2 order-sm-1 order-md-1 order-lg-1">
                    <div className="rishdining-img">
                        <div>
                            <img src="/image/rishikesh-dining-1.webp" className='img-responsive' alt="dining" loading="lazy"/>
                        </div>
                        <img src="/image/rishikesh-dining-2.webp" className='img-responsive wow animate__animated animate__slideInLeft' data-wow-delay="0.1s" data-wow-duration="1.2s" alt="dining" loading="lazy"/>
                    </div>
                </div>

                 <div className="col-lg-5 col-sm-5 col-md-5 order-1 order-sm-2 order-md-2 order-lg-2">
                    <p>Savor a refined dining experience where carefully crafted dishes celebrate rich flavors and fresh ingredients. Each meal is thoughtfully prepared to offer a memorable and elegant culinary journey. A warm and inviting ambience enhances every moment of your dining experience.</p>
                    <img src="/image/rishikesh-dining-3.webp" className='img-responsive wow animate__animated animate__slideInRight' data-wow-delay="0.1s" data-wow-duration="1.2s" alt="dining" loading="lazy"/>
                </div>

            </div>
        </div>
    </section>
    </>
  )
}
